import {useState, useEffect, useMemo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from '../helpers/api';
import { Container, Table, Button, Modal, Form, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AdvancedSearchModal from '../modals/AdvancedSearchModal';
import IapLookupModal from '../modals/IapLookupModal';



export default function Customers() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const user = useSelector(state => state.user);
    const accounts = useSelector(state => state.accounts);
    const [searchParams, setSearchParams] = useState(() => ({
        emailAddress: '',
        pageNumber: 1,
        rowsPerPage: 50
    }));
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
    const [showIapLookup, setShowIapLookup] = useState(false);
    //Check Authorization
    useEffect(() => {
        isAuthorized().then(auth => {
            if (!auth) {
                navigate('/');
            }
        });
    }, [])

    const isAuthorized = async () => {
        try {
            const response = await api.checkAuth();
            return response; //True or False
        } catch (error) {
            return false;
        }
    }

    const handleSearch = (e) => {
        e.preventDefault();
        try {
            setSearchParams(prev => ({...prev, pageNumber: 1}));
            api.searchAccounts({...searchParams, pageNumber: 1});
            // Dispatch search action with searchParams
        } catch (error) {
            console.error("Error searching accounts:", error);
        }
    }

    const paginationUpdate = (key, value) => {
        try {
            setSearchParams(prev => ({...prev, [key]: value}));
            api.searchAccounts({...searchParams, [key]: value});
        } catch (error) {
            console.error("Error updating pagination:", error);
        }
    }

    let modal = null;
    if (showAdvancedSearch) {
        modal = <AdvancedSearchModal close={() => setShowAdvancedSearch(false)} />
    } else if (showIapLookup) {
        modal = <IapLookupModal close={() => setShowIapLookup(false)} />
    }

    return (
        <Container className="mt-5">
            {modal}
            <Card bg="dark" text="white">
            <Card.Header><h5>Customer Lookup</h5></Card.Header>
             <Card.Body>
            <Form onSubmit={handleSearch}>
                <h6>Customer Email Address</h6>
                <Row >
                    
                    <Col xs="auto">
                        <Form.Group>
                            <Form.Label htmlFor="emailAddress" visuallyHidden>Customer Email Address</Form.Label>
                            <Form.Control
                                id="emailAddress"
                                name="emailAddress"
                                type="text"
                                placeholder="Email Address"
                                value={searchParams.emailAddress}
                                onChange={(e) => setSearchParams({...searchParams, emailAddress: e.target.value})}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs="auto">
                        <Button type="submit">Search</Button>
                    </Col>

                    <Col xs="auto">
                        <Button variant="secondary" onClick={() => setShowAdvancedSearch(true)}>Advanced Search</Button>
                    </Col>

                    <Col xs="auto">
                        <Button variant="info" onClick={() => setShowIapLookup(true)}>IAP Order Lookup</Button>
                    </Col>
                </Row>
            </Form>

            <hr/>
            <h5>Search Results</h5>
            <Row className="mb-5">
                <Col xs="auto"><Button disabled={searchParams.pageNumber <= 1} onClick={() => paginationUpdate("pageNumber", searchParams.pageNumber - 1)}>Previous</Button></Col>
                <Col xs="auto" className="d-flex align-items-center">
                    <Form.Select value={searchParams.rowsPerPage} onChange={(e) => paginationUpdate("rowsPerPage", e.target.value)}>
                        <option value={10}>10 Per Page</option>
                        <option value={20}>20 Per Page</option>
                        <option value={30}>30 Per Page</option>
                        <option value={40}>40 Per Page</option>
                        <option value={50}>50 Per Page</option>
                    </Form.Select>
                </Col>
                <Col xs="auto"><Button onClick={() => paginationUpdate("pageNumber", searchParams.pageNumber + 1)}>Next</Button></Col>
            </Row>
            <Table striped bordered hover variant="dark" responsive>
                <thead>
                    <tr>
                        <th>Email Address</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Phone</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {accounts.accounts.map(account => (
                        <tr onClick={() => navigate(`/customer/${account.accountReference}`)} style={{cursor: 'pointer'}} key={account.id}>
                            <td>{account.email}</td>
                            <td>{account.firstName}</td>
                            <td>{account.lastName}</td>
                            <td>{account.phoneNumber} | {account.mobileNumber}</td>
                            <td>{account.status}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
             </Card.Body>
            </Card>
        </Container>
    )
}